import {
  CONVERSATION_MESSAGE_ITEM_STATUS,
  CONVERSATION_MESSAGE_ITEM_STATUS_DELIVERED,
  CONVERSATION_MESSAGE_ITEM_STATUS_READ,
  CONVERSATION_MESSAGE_STATUS_DELIVERED_ACK
} from '@/config/api/api-routes';
import { http } from '@/shared/api/http';
import { getDeviceId } from '@/shared/helpers';
import type { ResultApi } from '@/shared/types/result-api';
import type {
  AckMultipleDeliveredDto,
  MessageStatusOverviewDto,
  MessageStatusUsersResponseDto
} from '../models/message-status';

class MessageStatusService {
  /**
   * Get message status overview
   */
  async getMessageStatus(conversationId: string, messageId: string): Promise<ResultApi<MessageStatusOverviewDto>> {
    const url = CONVERSATION_MESSAGE_ITEM_STATUS.replace(':conversationId', conversationId).replace(
      ':messageId',
      messageId
    );
    const response = await http.get<ResultApi<MessageStatusOverviewDto>>(url);
    return response.data;
  }

  /**
   * Get delivered users (paginated)
   */
  async getDeliveredUsers(
    conversationId: string,
    messageId: string,
    pageSize = 50,
    pagingState?: string
  ): Promise<ResultApi<MessageStatusUsersResponseDto>> {
    const url = CONVERSATION_MESSAGE_ITEM_STATUS_DELIVERED.replace(':conversationId', conversationId).replace(
      ':messageId',
      messageId
    );

    const params: Record<string, any> = { pageSize };
    if (pagingState) params.pagingState = pagingState;

    const response = await http.get<ResultApi<MessageStatusUsersResponseDto>>(url, { params });
    return response.data;
  }

  /**
   * Get read users (paginated)
   */
  async getReadUsers(
    conversationId: string,
    messageId: string,
    pageSize = 50,
    pagingState?: string
  ): Promise<ResultApi<MessageStatusUsersResponseDto>> {
    const url = CONVERSATION_MESSAGE_ITEM_STATUS_READ.replace(':conversationId', conversationId).replace(
      ':messageId',
      messageId
    );

    const params: Record<string, any> = { pageSize };
    if (pagingState) params.pagingState = pagingState;

    const response = await http.get<ResultApi<MessageStatusUsersResponseDto>>(url, { params });
    return response.data;
  }

  /**
   * Acknowledge delivered messages (HTTP fallback)
   */
  async ackDeliveredMessages(conversationId: string, dto: AckMultipleDeliveredDto): Promise<ResultApi<any>> {
    const url = CONVERSATION_MESSAGE_STATUS_DELIVERED_ACK.replace(':conversationId', conversationId);

    // Ensure client info is present
    if (!dto.clientType) dto.clientType = 'web';
    if (!dto.deviceId) dto.deviceId = getDeviceId();

    const response = await http.post<ResultApi<any>>(url, dto);
    return response.data;
  }
}

export const messageStatusService = new MessageStatusService();
